<template>
    <l-layout v-loading="ailoading" style="background: #fff;" :right="getDescriptionWidth">
        <l-ai-chat-panel v-show="chatVisible" :closable="true" @close="handleChatClose"></l-ai-chat-panel>
        <l-code-editor v-show="!chatVisible" v-model="value2" 
            ref="msgList"
            :readonly="readonly"
            :disabled="disabled"
                       isHint 
                       :handleHint="handleHint"
                       :theme="theme"
                       :mode="mode">
        </l-code-editor>
        <template #right>
            <l-layout style="background: #fff;" :top="40">
                <el-alert v-if="!!CodeDescription && CodeDescription != ''" title="" type="warning" :closable="false">
                    {{ CodeDescription }}
                </el-alert>
                <el-alert v-else-if="mode=='text/x-csharp'" title="" type="warning" :closable="false">
                    服务器端代码
                    <br />Parameters:传入的参数，字符串类型;
                    <br />打开数据库的方法;
                    <br />IRepository GetIRepository(string dbtype, string dblink, bool isTenant = true);
                    <br />IRepository BaseRepository(bool isTenant = true, bool isIgnoreHttpItem = false);
                    <br />IRepository BaseRepository(string code, bool isTenant = true);
                    <br />IRepository BaseRepository(string conn, string dbType, bool isTenant = true);
                    <br />主数据库开启事务：this.BeginTrans();this.Commit();this.Rollback();
                    <br />调用其他模块 var ibll = IocManager.Instance.GetServiceXXXXIBLL();
                    <br />$t('当前用户 var useribll = IocManager.Instance.GetServiceUserIBLL(); var userEntity=useribll.GetEntity();')
                </el-alert>
                <el-alert v-else-if="mode=='application/javascript'" title="" type="warning" :closable="false">
                  客户端代码
                  prop:组件id;
                  <br/>data:组件改变数据;
                  <br/>rowIndex:子表行号;
                  <br/>isUpdate:表单状态,新增或更新;
                  <br/>get(path):获取数据方法,
                  如果想获取某一个组件值就设置path参数值为组件id,
                  如果是子表的一行数据值就设置子表id.行号,
                  如果是子表某一行某一列值就设置子表id.行号.子组件id;
                  <br/>set(path,value):设置值方法,path说明和get方法一致;
                  <br/>getLabel(prop):获取组件的显示值,prop为组件id;
                  <br/>setRequired(prop,isRequired):设置组件是否必填,prop为组件id,isRequired 默认值true,如果取消必填就设置成false
                  <br/>setDisabled(prop,isDisabled):设置组件是否只读,prop为组件id,isDisabled 默认值true,如果取消只读就设置成false
                  <br/>setHide(prop,isHide):设置组件是否隐藏,isHide 默认值true,如果取消隐藏就设置成false
                  <br/>httpGet(option):get请求方法
                  <br/>httpPost(option):post请求方法
                  <br/>httpDelete(option):delete请求方法
                  <br/>httpPut(option):put请求方法
                  <br/>option:上面四个请求方法参数描述:url:请求地址,data:提交数据(get方法不支持),params:url参数,errorTips:请求失败错误提示,callback请求回调方法
                  返回结果为请求数据
                  <br/>loading:显示加载状态
                  <br/>hideLoading:隐藏加载状态
                  <br/>message:显示提示消息
                  <br/>loginUser:当前登录者信息
                  <br/>callback:回调方法,在脚本里使用了http方法后才需要使用
                  <br/>selectedValues:多选时被选中行的主键
                  <br/>selectedRows:多选时被选的行
                  <br/>mainTablePk:列表的主键字段名
                  <br/>tableData: 当前列表的所有数据
                  <br/>刷新页面：没有子页使用$this.refresh,刷新全部子页用$this.reload
                  <br/>caller: 当前查询页,类似于PreviewIndex,比如caller.$refs.mainTable取列表表格
                  <br/>txChina: 参数的对象集合,以上的属性或者函数通过txChina.XXX调用
                </el-alert>
                <template #top>
                    <div style="padding:5px;float:left">
                      <el-tooltip effect="dark" content="复制" placement="top">
                        <el-button v-show="!chatVisible" size="mini" circle @click="handleCopy" icon="el-icon-copy-document"></el-button>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="语法检查" placement="top">
                        <el-button v-show="!chatVisible && !readonly && disabled" size="mini" circle @click="handleChecking" icon="el-icon-position"></el-button>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="AI对话" placement="top">
                          <el-button v-if="showTools" size="mini" circle @click="handleChat" icon="el-icon-chat-dot-round"></el-button>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="代码库" placement="top">                        
                          <el-button v-if="showTools" size="mini" circle @click="handleSavedCode" icon="el-icon-files"></el-button>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="API文档" placement="top">                        
                          <el-button v-if="showTools" size="mini" circle @click="handleApiDocument" icon="el-icon-document"></el-button>
                      </el-tooltip>
                    </div>
                </template>
            </l-layout>
        </template>
        <l-fullscreen-dialog
            :title="$t(ApiTitle)"
            :visible.sync="apiShow"
            :showOk="false"
        >
            <div class="article-content-container">
                <div class="article-content" v-html="compiledMarkdown"></div>
            </div>
        </l-fullscreen-dialog>
    </l-layout>
    
  </template>
  <script>
  import MarkdownIt from 'markdown-it'
  import hljs from 'highlight.js'
  import './index.less'
  export default {
    name:'l-code-editor-panel',
    props:{
        value:{
  
        },
        mode: {
            type:String,
            default: 'text/x-csharp'
        },
        CodeDescription:{
            type: String,
            default: ''
        },
        Hints: {
            type: Array,
            default: () => []
        },
        onHinting: {  // 数据缺失时的回调
            type: Function,
            default: null
        },
        theme:{
            type:String,
            default: 'erlang-dark'
        },
        category:{
            type:String,
            default: 'formEvent'
        },
        method:{
            type:String,
            default: 'CallFunction'
        },
        params:{
            type:String,
            default: ''
        },
        readonly: Boolean,
        disabled: Boolean,
        showTools: {
            type: Boolean,
            default: true
        }
    },
    data(){
        return {
            content: '',
            ailoading : false,
            chatVisible: false,
            apiShow: false,
            md: new MarkdownIt({
                html: true,
                linkify: true,
                typographer: true,
                highlight: function (str, lang) {
                if (lang && hljs.getLanguage(lang)) {
                    try {
                    return hljs.highlight(lang, str).value
                    } catch (err) {

                    }
                }
                return hljs.highlightAuto(str).value
                }
            })
        };
    },
    computed:{
        ApiTitle(){
            return `API在线文档[${this.mode}]`
        },
        compiledMarkdown: {
            cache: true,
            get() {
            return this.md.render(this.$hints.generateDocs() || '');
            }
        },
        getDescriptionWidth(){
            if(this.readonly || this.disabled)
                return 0;
            if(!!this.CodeDescription || ['text/x-csharp','application/javascript'].indexOf(this.mode) != -1)
                return 260;
            return 0;
        },
        value2:{
            get(){
                return this.value || '';
            },
            set(val){
                this.$emit('input', val);
                this.$emit('change', val);
            }
        }
    },
    methods:{
        handleChatClear(){
            this.value2 = ''
        },
        sendChat(){
            this.ailoading = true;
            var content = this.content;
            this.content = '';
            window.$api.ai.platform.chat('', { content }).then(res=>{
                  this.value2 = res.data;
                this.ailoading = false
            }).catch(()=>{
                this.ailoading = false
            });
        },
        handleApiDocument(){
            this.apiShow = true
        },
        handleSavedCode(){
  
        },
        handleChat(){
            this.chatVisible = !this.chatVisible
        },
        handleChatClose(){
            this.chatVisible = false
        },
        handleCopy(){
            this.value2 && this.$copyText(this.value2).then(function () {
                alert('已复制')
            })
        },
        handleChecking(){
            this.validate( res=>{
                if(res){
                    this.$message.success('检查通过')
                }
            });
        },
        validate(callback){
            this.validate2(this.category, this.method, this.params, res=>{
              callback && callback(res)
            });
        },
        validate2(category, method, params, callback){
            if(this.mode == 'text/x-csharp' && !this.$validatenull(this.value2)){
                this.httpPost({url: 'code/build', params:{}, data:
                {
                    category: category,// || 'formEvent',
                    method: method,// || 'CallFunction',
                    body: this.lr_Base64Encode(this.value2),
                    arguments: params || ''
                }, callback})
            }
            else{
                callback( {res:true})
            }
        },
        handleHint(cursor, token, value2) {
            var text = token.string
            text = (text || '').replace(/'/g, '').replace(/"/g, '');
            // 使用合并后的提示数据
            let hints = this.Hints.filter(t => 
                (t.label && t.label.indexOf(text) !== -1) || 
                (t.prop && t.prop.indexOf(text) !== -1)
            );
            if (hints.length === 0 && this.onHinting) {
                try {
                    const newHints = this.onHinting(cursor, token, value2, );
                    if (newHints && newHints.length > 0) {                       
                        hints = newHints;
                    }
                } catch (e) {
                    console.error('获取提示数据失败:', e);
                }
            }
            
            return hints.map(t => 
                t.component ? `/*${t.label}*/"${t.prop}"` : `${t.prop}`
            );
        },
        extractLastValidPath(code){
            // 1. 预处理：去除空行和首尾空白
            const lines = code.split('\n')
                .map(line => line.trim())
                .filter(line => line.length > 0);

            let validPath = '';
            let shouldContinue = true;

            // 2. 反向遍历行
            for (let i = lines.length - 1; i >= 0 && shouldContinue; i--) {
                const currentLine = lines[i];
                let newPath = '';

                // 3. 决定如何连接路径
                if (validPath === '') {
                    newPath = currentLine;
                } else if (validPath.startsWith('.') && !currentLine.endsWith('.')) {
                    newPath = currentLine + validPath;
                } else if (!validPath.startsWith('.') && currentLine.endsWith('.')) {
                    newPath = currentLine + validPath;
                } else {
                    shouldContinue = false;
                    continue;
                }

                // 4. 验证路径合法性
                if (/^[a-zA-Z][a-zA-Z0-9.]*$/.test(newPath)) {
                    validPath = newPath;
                    shouldContinue = !newPath.includes('..');
                } else {
                    shouldContinue = false;
                }
            }

            // 5. 查找最后一个非字母、非数字、非点的字符位置
            let lastInvalidPos = -1;
            for (let i = validPath.length - 1; i >= 0; i--) {
                const char = validPath[i];
                if (!/[a-zA-Z0-9.]/.test(char)) {
                    lastInvalidPos = i;
                    break;
                }
            }

            // 6. 截取该位置之后的字符串
            if (lastInvalidPos !== -1) {
                validPath = validPath.substring(lastInvalidPos + 1);
            }

            // 7. 确保最终路径仍然合法
            if (validPath && (!/^[a-zA-Z][a-zA-Z0-9.]*$/.test(validPath) || validPath.includes('..'))) {
                validPath = '';
            }

            // 8. 返回结果（如果没有有效路径，返回清理后的输入文本）
            return validPath;
        },
        async httpGet({url, params,callback}){
            const res = await this.$awaitWraper(window.$axios({
                url: `${url}`,
                method: 'get',
                params
            }))
            callback && callback(res)
        },
        async httpPost({url, params,data, callback}){
            const res = await this.$awaitWraper(window.$axios({
                url: `${url}`,
                method: 'post',
                params,
                data
            }))
            callback && callback(res)
        },
        async httpPut({url, params,data,callback}){
            const res = await this.$awaitWraper(window.$axios({
                url: `${url}`,
                method: 'put',
                params,
                data
            }))
            callback && callback(res)
        },
        async httpDelete({url, params,data,callback}){
            const res = await this.$awaitWraper(window.$axios({
                url: `${url}`,
                method: 'delete',
                params,
                data
            }))
            callback && callback(res)
        },
        //创建JavaScript脚本函数
        buildFunction(strEvent) {
            if (!this.$validatenull(strEvent)) {
                strEvent = `(function(){function fn(txChina, callback) { var $p=txChina; var $this=$p.caller; ${strEvent}} return fn})()`
                return this.$getFunction(strEvent)
            }
            else {
                return { res: false, msg: '没设置脚本函数！' }
            }
        },
        //执行JavaScript脚本函数
        processEvent(strEvent, Parameters){
            return new Promise(resolve => {
                const myEvent = this.buildFunction(strEvent)
                if (myEvent.res) {
                    const result = myEvent.fn(Parameters, result => {
                        resolve({res: true, result})
                    })
                    if (result != 'callback') {
                        resolve({res: true, result})
                    }
                }
                else {
                    resolve(myEvent)
                }
            })
        },
        getValue(data, path) {
            const paths = path.split('.')
            for (let i = 0, len = paths.length; i < len; i++) {
                data = data[paths[i]]
            }
            return data
        },
        setValue(data, path, value ) {
            const paths = path.split('.')
            if (paths.length == 2) {
                this.$set(data[paths[0]], paths[1], value)
            }
            else if (paths.length == 3 && data[paths[0]]) {
                this.$set(data[paths[0]][paths[1]], paths[2], value)
            }
            else {
                this.$set(data, path, value)
            }
        }
    }
  }
  </script>
 